import React, { useState } from "react";
import { getDynamicIconSize } from "../../liveBusLocations/tools";
import MapLocationDotIcon from "../../../components/icons/MapLocationDotIcon";
import { Divider, ListItem, ListItemText, Typography } from "@material-ui/core";
import List from "@material-ui/core/List";
import PeopleIcon from "@material-ui/icons/People";

interface IMarker {
  lat: number;
  lng: number;
  key: string;
  zoom: number;
  order: number;
  data: any;
  colorOne?: string;
  colorTwo?: string;
}

const LocationMarker = ({ zoom, order, colorOne, colorTwo, data }: IMarker) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const iconSize = getDynamicIconSize(zoom);

  return (
    <div
      style={{
        width: `${iconSize}px`, // Dynamic size based on zoom level
        height: `${iconSize}px`, // Dynamic size based on zoom level
        position: "absolute",
        transform: "translate(-50%, -100%)",
        cursor: "pointer",
        zIndex: isPopupVisible ? 11 : 10,
      }}
      onClick={() => {
        setIsPopupVisible(!isPopupVisible); // Toggle popup locally
      }}
    >
      <MapLocationDotIcon
        width={iconSize}
        height={iconSize}
        colorOne={colorOne}
        colorTwo={colorTwo}
      />

      {/* Number overlay */}
      <span
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "white", // Contrast with the marker image
          fontWeight: "bold",
          fontSize: `${Math.max(10, iconSize * 0.5)}px`, // Scale with iconSize, with a minimum size
          pointerEvents: "none", // Ensures the number doesn't block clicks
        }}
      >
        {order}
      </span>

      {/* Total passengers overlay */}
      {zoom >= 16 && data.passengers && data.passengers.length > 0 && (
        <div
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "black",
            padding: "4px",
            borderRadius: "4px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
            whiteSpace: "nowrap",
            zIndex: 2,
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <PeopleIcon fontSize="small" style={{ marginRight: "4px" }} />
            <span
              style={{
                fontSize: `${Math.max(10, iconSize * 0.5)}px`,
                fontWeight: "bold",
              }}
            >
              {data.passengers.length}
            </span>
          </div>
        </div>
      )}

      {/* Conditional Popup */}
      {isPopupVisible && (
        <div
          style={{
            position: "absolute",
            bottom: iconSize + 10, // Show above the marker
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "black",
            padding: "6px 12px",
            borderRadius: "4px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
            whiteSpace: "nowrap",
            zIndex: 2,
            fontSize: "12px",
            fontWeight: "normal",
          }}
        >
          <Typography variant="body2" gutterBottom>
            <strong>{data.routeName}</strong> - {data.address}
          </Typography>

          {data.passengers && data.passengers.length > 0 && (
            <>
              <Divider style={{ margin: "10px 0px" }} />
              <Typography variant="body2" style={{ fontWeight: "bold" }}>
                Students:
              </Typography>
              <List dense style={{ padding: 0 }}>
                {data.passengers.map((passenger: any, index: number) => (
                  <ListItem key={index} dense disableGutters>
                    <ListItemText
                      primary={`${passenger.student.firstName} ${passenger.student.lastName}`}
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default LocationMarker;
